module.exports = __webpack_public_path__ + "static/media/navigation-arrow.d8c91854.svg";